/**
 * Pending Approval Page
 *
 * Shown to users whose profile is awaiting admin approval
 */

import { useAuth } from '../../hooks/useAuth';

export function PendingApproval() {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div class="flex items-center justify-center py-12">
      <div class="max-w-2xl w-full">
          <div class="bg-white shadow-lg rounded-lg overflow-hidden">
            {/* Icon section */}
            <div class="bg-yellow-50 px-6 py-12 text-center">
              <div class="inline-flex items-center justify-center w-20 h-20 rounded-full bg-yellow-100 mb-4">
                <svg class="w-10 h-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h2 class="text-3xl font-bold text-gray-900 mb-2">
                Tu Solicitud Está en Revisión
              </h2>
              <p class="text-lg text-gray-600">
                Hemos recibido tu perfil correctamente
              </p>
            </div>

            {/* Information section */}
            <div class="px-6 py-8">
              <div class="space-y-6">
                <div>
                  <h3 class="text-lg font-semibold text-gray-900 mb-3">
                    ¿Qué sigue ahora?
                  </h3>
                  <div class="space-y-4">
                    <div class="flex">
                      <div class="flex-shrink-0">
                        <div class="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-600 font-semibold text-sm">
                          1
                        </div>
                      </div>
                      <div class="ml-4">
                        <p class="text-gray-700">
                          <span class="font-medium">Revisión de documentación:</span> Nuestro equipo verificará tu certificado y datos proporcionados.
                        </p>
                      </div>
                    </div>

                    <div class="flex">
                      <div class="flex-shrink-0">
                        <div class="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-600 font-semibold text-sm">
                          2
                        </div>
                      </div>
                      <div class="ml-4">
                        <p class="text-gray-700">
                          <span class="font-medium">Notificación por email:</span> Te enviaremos un correo con el resultado de la revisión.
                        </p>
                      </div>
                    </div>

                    <div class="flex">
                      <div class="flex-shrink-0">
                        <div class="flex items-center justify-center h-8 w-8 rounded-full bg-blue-100 text-blue-600 font-semibold text-sm">
                          3
                        </div>
                      </div>
                      <div class="ml-4">
                        <p class="text-gray-700">
                          <span class="font-medium">Siguiente paso:</span> Si tu solicitud es aprobada, recibirás instrucciones para completar el pago anual.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="border-t border-gray-200 pt-6">
                  <h4 class="text-sm font-semibold text-gray-900 mb-2">
                    Tiempo estimado de revisión
                  </h4>
                  <p class="text-gray-600">
                    Normalmente procesamos las solicitudes en <span class="font-semibold">2-5 días hábiles</span>.
                    Te mantendremos informado del progreso por email.
                  </p>
                </div>

                <div class="bg-blue-50 border-l-4 border-blue-400 p-4">
                  <div class="flex">
                    <div class="flex-shrink-0">
                      <svg class="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                      </svg>
                    </div>
                    <div class="ml-3">
                      <p class="text-sm text-blue-700">
                        <span class="font-medium">Importante:</span> Puedes cerrar sesión y volver más tarde.
                        Te notificaremos por email cuando haya novedades.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Contact information */}
                <div class="border-t border-gray-200 pt-6">
                  <h4 class="text-sm font-semibold text-gray-900 mb-2">
                    ¿Necesitas ayuda?
                  </h4>
                  <p class="text-gray-600 text-sm">
                    Si tienes alguna pregunta o necesitas actualizar tu información, contáctanos en:{' '}
                    <a href="mailto:soporte@fitbook.es" class="text-blue-600 hover:text-blue-800 font-medium">
                      soporte@fitbook.es
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* User info card */}
          <div class="mt-6 bg-white shadow rounded-lg px-6 py-4">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm text-gray-500">Usuario registrado</p>
                <p class="text-lg font-medium text-gray-900">{user.email}</p>
              </div>
              <div class="text-right">
                <p class="text-sm text-gray-500">Estado actual</p>
                <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
                  Pendiente de Aprobación
                </span>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
}
